import SiteFooter from '../components/Footer';

export const Footer = () => SiteFooter;
